module.exports = __webpack_public_path__ + "static/media/icon_floor.6bb9ddcb.svg";